import * as React from "react";
import { CustomerTaxResidencyTable } from "./Components/Regulatory/CustomerTaxResidencyTable";
import { ReportingTaxYearSettingTable } from "./Components/Regulatory/ReportingTaxYearSettingTable";
import { IClientTabProps } from "./Resource/Contents";
import { TaxFormSection } from "./Components/Regulatory/TaxFormSection";
import { HighValueSection } from "./Components/Regulatory/HighValueSection";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { Permission } from "../../../../Shared/Permission/Permission";
import { CustomerTaxResidencyModel } from "../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { ClientRecordAction } from "./Action/ClientRecordAction";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { ControllingPersonDetails } from "./Components/Regulatory/ControllingPersonDetails";
import { ControllingPersonRoleDetailModel } from "../../../../../Wrap/Models/Models/Customer/ControllingPersonRoleDetailModel";
import { ControllingPersonRoleDetailCollectionModel } from "../../../../../Wrap/Models/Models/Customer/ControllingPersonRoleDetailCollectionModel";
import { ControllingPersonType } from "../../../../../Wrap/Constants/Enums/Customer/ControllingPersonType";
import { TaxComplianceAgreement } from "./Components/Regulatory/TaxComplianceAgreement";
import { AccountInfoAction } from "../../../../../applications/Dashboard/Components/Clients/PortfolioDashboard/Components/Role/Action/AccountInfoAction";
import { CustomerCompliance } from "../../../../../Wrap/Models/Domains/Regulations/CustomerCompliance";

interface IRegulatoryState {
    customerid: number;
    data: Array<CustomerTaxResidencyModel>;
    controllingPersonData: Array<ControllingPersonRoleDetailModel>;
    isControllingPersonLoading: boolean;
    isLoading: boolean;
    loadComplianceTable: boolean;
    customerComplianceList: Array<CustomerCompliance>;
    firstLoadTaxCompliance: boolean;
}
export class Regulatory extends React.Component<IClientTabProps, IRegulatoryState> {
    constructor(props: any) {
        super(props);
        this.state = {
            customerid: Number(this.props.id),
            data: [],
            controllingPersonData: [],
            isControllingPersonLoading: false,
            isLoading: false,
            loadComplianceTable: false,
            customerComplianceList: [],
            firstLoadTaxCompliance: true,
        };
    }

    componentDidMount() {
        this.setState({ isLoading: true, isControllingPersonLoading: true });
        this.reloadTable();
    }

    reloadTable() {
        ClientRecordAction.getCutomerTaxResidency(this.state.customerid, (val) => {
            this.setState({
                data: val,
                isLoading: false,
            });
        });

        this.getControllerPersonData();
    }

    getNewComliance() {
        AccountInfoAction.getCustomerRegulationCompliance(this.state.customerid, (result) => {
            this.setState({ customerComplianceList: result });
        });
    }

    loadCompleted() {
        this.setState({
            loadComplianceTable: false,
        });
    }

    needReload() {
        this.setState({
            loadComplianceTable: true,
            firstLoadTaxCompliance: false,
        });
        this.getNewComliance();
    }

    private getControllerPersonData() {
        ClientRecordAction.getControllingPersonDetail(
            this.state.customerid.toString(),
            (val: ControllingPersonRoleDetailCollectionModel) => {
                this.setState({
                    controllingPersonData: val?.Results,
                    isControllingPersonLoading: false,
                });
            }
        );
    }

    private onControllingPersonSave(data: ControllingPersonRoleDetailModel, selectedType: ControllingPersonType) {
        data.ControllingPersonType = selectedType;
        this.setState({ isControllingPersonLoading: true });
        ClientRecordAction.updateControllingPersonType(data, (val) => {
            this.getControllerPersonData();
        });
        return true;
    }

    render(): JSX.Element {
        const { customerid, data, isLoading } = this.state;
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        return (
            <div className="panel-subtle pl-34 pt-38">
                <CustomerTaxResidencyTable
                    customerid={customerid}
                    data={data}
                    hasReadWriteAccess={this.props?.hasReadWriteAccess}
                    controllingPersonData={this.state?.controllingPersonData}
                    reloadTable={() => this.reloadTable()}
                    needReload={() => this.needReload()}
                />
                <hr />
                <Permission userClaim={UserClaim.AdviserPortalCustomerFullyAccessCanView}>
                    <>
                        <div className="panel-subtle">
                            <TaxFormSection
                                customerid={customerid}
                                data={data}
                                hasReadWriteAccess={this.props?.hasReadWriteAccess}
                            />
                        </div>
                        <hr />
                        <ReportingTaxYearSettingTable
                            customerid={customerid}
                            hasReadWriteAccess={this.props?.hasReadWriteAccess}
                        />
                        <div className="panel-subtle">
                            <HighValueSection
                                customerid={customerid}
                                hasReadWriteAccess={this.props?.hasReadWriteAccess}
                            />
                        </div>
                        <ControllingPersonDetails
                            customerid={customerid}
                            hasReadWriteAccess={this.props?.hasReadWriteAccess}
                            data={this.state?.controllingPersonData}
                            residencyData={this.state?.data}
                            isLoading={this.state?.isControllingPersonLoading}
                            onSave={(controlPersonData, selectedType) =>
                                this.onControllingPersonSave(controlPersonData, selectedType)
                            }
                        />
                        <hr />
                        <TaxComplianceAgreement
                            customerId={customerid}
                            hasReadWriteAccess={this.props?.hasReadWriteAccess}
                            customerComplianceList={this.state.customerComplianceList}
                            loadCompleted={() => this.loadCompleted()}
                            firstLoad={this.state.firstLoadTaxCompliance}
                        />
                    </>
                </Permission>
            </div>
        );
    }
}
